export default __webpack_public_path__ + "static/brauhaus-darts-wm-24-preview-a5420ba7e980d3762fe3897e80e6b165.jpg";